export enum LicenseKeysMeta {
  MODEL = "licensekeys",
  PK = "id",
}
